import { Team__Cerveceros } from "../teams/Cerveceros";
import { Team__LaChona } from "../teams/LaChona";
import { Team__FloresMagon } from "../teams/FloresMagon";
import { Team__FoxImpresos } from "../teams/FoxImpresos";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__Apaches } from "../teams/Apaches";
import { Team__Aliados } from "../teams/Aliados";

const Cerveceros = {
  team: Team__Cerveceros,
  playingPlayers: [],

  goals: 44,
  penaltyGoals: 0,
  isWinner: false,
};

const LaChona = {
  team: Team__LaChona,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const FloresMagon = {
  team: Team__FloresMagon,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const FoxImpresos = {
  team: Team__FoxImpresos,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 49,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 58,
  penaltyGoals: 0,
  isWinner: false,
};

const LaChona_2 = {
  team: Team__LaChona,
  playingPlayers: [],

  goals: 50,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: Aliados,
      team2: LaChona_2,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: FloresMagon,
      team2: FoxImpresos,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleros,
      team2: Apaches,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Cerveceros,
      team2: LaChona,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
